
const API_URL = 'https://lp.msu.edu.in/lead'

export const sendOtp = async (phoneNumber) => {

  try {
    const res = await fetch(`${API_URL}/api/send-otp`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ phoneNumber }),
    });

    const data = await res.json();
    return data;

  } catch (error) {
    console.error("Send OTP Error:", error);
    throw error;
  }
};


export const verifyOtp = async (phoneNumber, otp) => {
  try {
    const res = await fetch(`${API_URL}/api/verify-otp`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        phoneNumber,
        otp,
      }),
    });

    const data = await res.json();
    return data;

  } catch (error) {
    console.error("Verify OTP Error:", error);
    throw error;
  }
};